export default "query howToContactTypes{\n     howToContactTypes\n}";